/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Certificate } from '../models/Certificate';
import type { CreateCertificateDto } from '../models/CreateCertificateDto';
import type { UpdateCertificateDto } from '../models/UpdateCertificateDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CertificateService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns Certificate
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody: CreateCertificateDto,
  }): CancelablePromise<Certificate> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/{associationUserId}/certificate',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns any[]
   * @throws ApiError
   */
  public find(): CancelablePromise<any[]> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/{associationUserId}/certificate',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public updateById({
    id,
    requestBody,
    relations,
  }: {
    id: number,
    requestBody: UpdateCertificateDto,
    relations?: Array<string>,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/v1/{associationUserId}/certificate/{id}',
      path: {
        'id': id,
        'relations': relations,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public deleteById({
    id,
    relations,
  }: {
    id: number,
    relations?: Array<string>,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/v1/{associationUserId}/certificate/{id}',
      path: {
        'id': id,
        'relations': relations,
      },
    });
  }
}
